import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'unauthorized',
    canActivate: [authGuard],
    loadComponent: () => import('./features/shared/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: 'maker',
    canActivate: [authGuard, roleGuard],
    data: { role: 'MAKER' },
    loadComponent: () => import('./features/maker/maker-shell/maker-shell.component').then(m => m.MakerShellComponent),
    children: [
      { path: '', redirectTo: 'documents', pathMatch: 'full' },
      {
        path: 'documents',
        loadComponent: () => import('./features/maker/my-documents/my-documents.component').then(m => m.MyDocumentsComponent)
      },
      {
        path: 'upload',
        loadComponent: () => import('./features/maker/upload/upload-page.component').then(m => m.UploadPageComponent)
      },
      {
        path: 'edit/:id',
        loadComponent: () => import('./features/maker/edit-document/edit-document.component').then(m => m.EditDocumentComponent)
      },
      {
        path: 'documents/:id',
        loadComponent: () => import('./features/shared/document-detail/document-detail.component').then(m => m.DocumentDetailComponent)
      },
      {
        path: 'calendar-events/edit/:id',
        loadComponent: () => import('./features/maker/edit-calendar-event/edit-calendar-event.component').then(m => m.EditCalendarEventComponent)
      },
      {
        path: 'calendar-events/:id',
        loadComponent: () => import('./features/shared/calendar-event-detail/calendar-event-detail.component').then(m => m.CalendarEventDetailComponent)
      },
      {
        path: 'ibe-uploads/edit/:id',
        loadComponent: () => import('./features/maker/edit-ibe-upload/edit-ibe-upload.component').then(m => m.EditIbeUploadComponent)
      },
      {
        path: 'ibe-uploads/:id',
        loadComponent: () => import('./features/shared/ibe-upload-detail/ibe-upload-detail.component').then(m => m.IbeUploadDetailComponent)
      }
    ]
  },
  {
    path: 'checker',
    canActivate: [authGuard, roleGuard],
    data: { role: 'CHECKER' },
    loadComponent: () => import('./features/checker/checker-shell/checker-shell.component').then(m => m.CheckerShellComponent),
    children: [
      { path: '', redirectTo: 'documents', pathMatch: 'full' },
      {
        path: 'documents',
        loadComponent: () => import('./features/checker/all-documents/all-documents.component').then(m => m.AllDocumentsComponent)
      },
      {
        path: 'documents/:id',
        loadComponent: () => import('./features/shared/document-detail/document-detail.component').then(m => m.DocumentDetailComponent)
      },
      {
        path: 'calendar-events/:id',
        loadComponent: () => import('./features/shared/calendar-event-detail/calendar-event-detail.component').then(m => m.CalendarEventDetailComponent)
      },
      {
        path: 'ibe-uploads/:id',
        loadComponent: () => import('./features/shared/ibe-upload-detail/ibe-upload-detail.component').then(m => m.IbeUploadDetailComponent)
      }
    ]
  },
  { path: '**', redirectTo: '/login' }
];

